// @ts-nocheck

import { createSelector } from 'reselect';

import { getIsHighlightFromProps } from '../../../../selectors/_propsGetters_';
import { type Selector } from '../../../../types/selectors';
import BoomUIBySkinId from '../../constants/ui';
import { selectBoomGlobalSkinId } from '../../selectors/global/globalPrimary.selector';

const selectColor: Selector<string> = createSelector(
  [getIsHighlightFromProps, selectBoomGlobalSkinId],
  (isHighlight, skinId) =>
    BoomUIBySkinId[skinId]?.TabBarItem[isHighlight ? 'active' : 'passive']?.color ?? 'transparent',
);

type BoomNavLabelPropsType = {
  color: string;
};

const selectBoomNavLabelProps: Selector<BoomNavLabelPropsType> = createSelector([selectColor], (color) => ({
  color,
}));

export default selectBoomNavLabelProps;
